var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97
    },
    fill: "#f7b731",
    d: "M 419.5,114.5 C 435.728,112.773 445.062,119.94 447.5,136C 446.843,141.308 445.01,146.141 442,150.5C 365.833,234.667 289.667,318.833 213.5,403C 204.291,407.881 195.291,407.548 186.5,402C 141.713,360.18 97.2131,318.013 53,275.5C 46.076,260.943 49.576,249.776 63.5,242C 69.619,239.907 75.619,240.24 81.5,243C 116.465,273.629 151.131,304.629 185.5,336C 196.418,344.933 206.918,344.433 217,334.5C 281.797,262.035 346.963,189.868 412.5,118C 414.925,116.787 417.259,115.621 419.5,114.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckYellow);
export default __webpack_public_path__ + "static/media/check-yellow.9512da6e934bcbb5fa79de13fd8bde98.svg";
export { ForwardRef as ReactComponent };